<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="login-field" type="text" v-checkenter="login" v-model="username" :placeholder="placeholder ? placeholder : 'E-mail'">
        </div>
        <div class="field-wrapper" v-if="usePassword">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="password" v-checkenter="login" v-model="password" :placeholder="passwordPlaceholder ? passwordPlaceholder : 'Senha'">
        </div>
        <input class="login-button" type="button" :value="cta ? cta : 'ENTRAR'" @click.prevent="login">
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    export default {
        name: 'EventbriteLogin',

        props: {
            usePassword: true,
            placeholder: null,
            passwordPlaceholder: '',
            cta: ''
        },

        data ()
        {
            return {
                username: '',
                password: ''
            }
        },

        methods: {
            
            async login ()
            {
                this.username = this.username.toLowerCase().trim();
                this.password = this.password.trim();

                if (!this.usePassword) this.password = this.username;

                if (this.username && this.password)
                {
                    api
                        .post(`event/${this.$store.state.eventId}/eventBrite/login`, { email: this.username, password: await encrypt(this.password) })
                        .then(response => {
                            this.$emit('logged', response);
                        })
                        .catch(err => {
                            console.log('catch');
                            if (err.response?.data.error.includes('Valid process expected'))
                            {
                                api
                                    .post(`event/${this.$store.state.eventId}/retryValidMail`, {
                                        email: this.username,
                                    })
                                    .then(response => {
                                        this.$emit('error', 'notValidated');
                                    })
                                    .catch(err => {
                                        this.$emit('error', 'fail');
                                    });
                            }
                            else
                            {
                                this.$emit('error', 'fail');
                            }
                        });
                }
                else
                {
                    // show error
                    this.$emit('error', 'fail');
                }
            }
        }
        
    }
</script>

<style lang="scss">
    
</style>